/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';
import PropTypes from 'prop-types';

import {
  appendThumborTransformQueryString,
} from '@lib/image';
import analyticsTrack from '@lib/analytics/analyticsTrack';
import LogoOutline from '@components/shared/images/atoms/LogoOutline/LogoOutline';
import { useTheme } from '@components/theme';
import styles from './DesignerInfo.module.scss';

DesignerInfo.propTypes = {
  className: PropTypes.string,
  designerBoard: PropTypes.shape({
    designer: PropTypes.shape({
      id: PropTypes.string.isRequired,
      profileUri: PropTypes.string.isRequired,
    }),
  }),
  small: PropTypes.bool,
};

DesignerInfo.defaultProps = {
  className: '',
  designerBoard: null,
  small: false,
};

export default function DesignerInfo({
  className,
  designerBoard,
  small,
}) {
  if (!designerBoard) {
    return null;
  }

  const theme = useTheme();

  const { designer } = designerBoard;

  const handleTrack = () => analyticsTrack(
    'explore_interior_designer_clicked',
    {
      designerId: designer ? designer.id : 0,
      viewedFrom: '/interior-design-ideas/design-board',
    },
  );

  return (
    <div className={ `${styles.Root} ${small ? styles.Small : ''} ${className || ''}` }>
      {
        !designer && (
          <>
            <span className={ styles.Photo } aria-hidden="true">
              <LogoOutline />
            </span>
            <span className={theme.styles.Title3}>designed by Havenly</span>
          </>
        )
      }
      {
        designer && (
          <>
            <a
              className={ styles.Photo }
              href={ designer.profileUri }
              onClick={ handleTrack }
              rel="noopener noreferrer"
              aria-label={designer.displayName}
              style={{
                backgroundImage: `url('${
                  appendThumborTransformQueryString({ url: designer.photo, width: 60 })
                }')`,
              }}
              target="_blank"
            />
            <span className={theme.styles.Title3}>
              Designed by&nbsp;
              <a
                className={ styles.NameLink }
                href={ designer.profileUri }
                onClick={ handleTrack }
                rel="noopener noreferrer"
                target="_blank"
              >
                { designer.firstName }
              </a>
            </span>
          </>
        )
      }
    </div>
  );
}

